import { createSlice } from '@reduxjs/toolkit';
import { validateModel, validateFormField } from '../validation/addressCapture';

const initialState = {
  validation: {},
  selectedAddressId: '',
  postCodeSearchValue: '',
  addressSearchResults: [],
  isDirty: false,
  manualAddressFlattened: null,
  showErrors: false
};

const addressCapture = createSlice({
  name: 'addressCapture',
  initialState,
  reducers: {
    searchByPostcode: (state, action) => {
      return {
        ...state,
        postCodeSearchValue: action.payload,
        addressSearchResults: [],
        isDirty: true,
        showErrors: false
      };
    },
    searchByPostcodeCompleted: (state, action) => {
      state.addressSearchResults = action.payload;
    },
    /** @todo  */
    searchByPostcodeRejected: (state, action) => {
      state.validation = validateModel(action.payload);
      state.showErrors = true;
    },
    changeAddress: (state, action) => {
      state.selectedAddressId = action.payload;
      state.isDirty = true;
    },
    /** @todo  */
    changeAddressCompleted: (state, action) => {},
    changeAddressRejected: (state, action) => {
      state.validation = validateModel(action.payload);
      state.showErrors = true;
    },
    resetValidation: (state) => {
      state.validation = {};
      state.canContinue = false;
    },
    invalidPostcodeError: (state, action) => {
      state.validation = validateModel(action.payload);
      state.showErrors = true;
    },
    validate: (state, action) => {
      state.validation = validateModel(action.payload);
    },
    validateField: (state, action) => {
      const { field, value } = action.payload;

      state.validation[field] = validateFormField(field, value);
    },
    resetState: () => initialState
  }
});

export { addressCapture };

export const {
  searchByPostcode,
  searchByPostcodeCompleted,
  searchByPostcodeRejected,
  changeAddress,
  changeAddressCompleted,
  changeAddressRejected,
  invalidPostcodeError,
  resetValidation,
  validate,
  validateField,
  resetState
} = addressCapture.actions;
